import React from 'react';
export const InAnotherOfficeCheck: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2786 5.52919L7.98836 11.8216C7.30488 12.5054 6.19644 12.5054 5.51297 11.8216L1.72168 8.02919L2.78256 6.96875L6.57385 10.7612C6.67149 10.8589 6.82984 10.8589 6.92748 10.7612L13.2177 4.46875L14.2786 5.52919Z"
      fill="currentColor"
    />
  </svg>
);
